// extracted by mini-css-extract-plugin
export var growableInput = "_8c-0";
export var tagContainer = "_8c-2";
export var textInput = "_8c-1";